import { Observable, observe, Scope } from 'wdc-cube'
import { FilterCatalogScope, type AppliedFilterSummary, type IFilterScope } from '../the-consumer-market/tcm_scopes'
import type { Indicador } from './ad_types'

export type Option<T extends string = string> = { value: T; label: string }

@Observable
export class KpiScope extends Scope {
    @observe() caption = ''
    @observe() hint = ''
    @observe() loaded = false
    @observe() texto = ''
    @observe() detalhe = ''
}

export type LinhaComparativo = {
    id: string
    rotulo: string
    valores: string[]
    detalhes: string[]
}

@Observable
export class ComparativoScope extends Scope {
    @observe() caption = ''
    @observe() loaded = false
    @observe() operadoras = [] as string[]
    @observe() linhas = [] as LinhaComparativo[]
    @observe() vazio = ''
}

export type SerieGrafico = { nome: string; valores: (number | null)[] }

export type FormatoGrafico = 'moeda' | 'indice' | 'percentual'

@Observable
export class GraficoScope extends Scope {
    @observe() caption = ''
    @observe() loaded = false
    @observe() indicador: Indicador = 'despesas_assistenciais'
    @observe() opcoes = [] as Option<Indicador>[]
    @observe() datas = [] as string[]
    @observe() series = [] as SerieGrafico[]
    @observe() formato: FormatoGrafico = 'moeda'

    onIndicadorChange = Scope.ASYNC_ACTION_ONE<Indicador>()
}

@Observable
export class AdFilterPaneScope extends Scope {
    readonly catalog = new FilterCatalogScope()
    @observe() catalogVisible = false

    @observe() expanded = false
    @observe() isFiltering = false
    @observe() searchFilterText = ''
    @observe() filters = [] as IFilterScope[]

    onToggleExpanded = Scope.ASYNC_ACTION
    onClearFilters = Scope.ASYNC_ACTION
    onApply = Scope.ASYNC_ACTION
    onSearchFilterChanged = Scope.ASYNC_ACTION_STRING
}

@Observable
export class HeaderScope extends Scope {}

@Observable
export class AnaliseDesempenhoScope extends Scope {
    readonly header = new HeaderScope()
    readonly filtros = new AdFilterPaneScope()

    readonly operadoras = new KpiScope()
    readonly beneficiarios = new KpiScope()
    readonly liquidezGeral = new KpiScope()
    readonly liquidezCorrente = new KpiScope()
    readonly sinistralidade = new KpiScope()

    readonly comparativo = new ComparativoScope()
    readonly grafico = new GraficoScope()

    @observe() atualizacao = ''
    @observe() appliedFilters = [] as AppliedFilterSummary[]
    @observe() avisoLimite = ''
    @observe() erro = ''
}

export default AnaliseDesempenhoScope
